import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IDecrementalTableReport,
  IDeltaHedgeTablesSearchParam,
} from "../../../Interfaces/deltaHedgeSettings";
import { getDecrementalTable } from "../../../Requests/deltaHedgeSettings";
import { Additional } from "./Additional";
import TableUI from "./TableUI";

interface IProps {
  searchParams: IDeltaHedgeTablesSearchParam;
}

const DecrementalTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeTablesSearchParam, IDecrementalTableReport>
      TableUI={({ reports, onAction }) => (
        <TableUI
          reports={reports}
          AdditionalBody={Additional}
          onAction={onAction}
        />
      )}
      searchParameters={searchParams}
      getDataTable={getDecrementalTable}
    />
  );
};

export default DecrementalTable;
